/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Feedback_Pagination_Page_OfInputs */

const es_feedback_pagination_page_of = /** @type {(inputs: Feedback_Pagination_Page_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
};

const en_feedback_pagination_page_of = /** @type {(inputs: Feedback_Pagination_Page_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.current} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Page {current} of {total}" |
*
* @param {Feedback_Pagination_Page_OfInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_pagination_page_of = /** @type {((inputs: Feedback_Pagination_Page_OfInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Pagination_Page_OfInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_pagination_page_of(inputs)
	return en_feedback_pagination_page_of(inputs)
});
export { feedback_pagination_page_of as "feedback.pagination.page_of" }